import setCriticalError from './set-critical-error';

export default {
  setCriticalError,
};
